export default {
  'en-US': {
    lang: 'en',
    home: {
      center_black: 'Put the back of the phone',
      center_yellow: 'aproach NFC Tag',
      keep_phone: 'Keep close to the tag',
      about_us: 'About us',
      product_introduced: 'Introduction',
      version_switch: 'Version switch',
      update: 'Update',
      reminder: 'Hint',
      feedback: 'feedback',
      hint_message: 'Unknown Error',
      error_message: 'The tag is not in ONLY ONE verification scope',
      hint_overtime: 'Keep the tag close to the phone',
      error_official: 'This tag is unoffice issue',
      error_authentication: 'The tag is not in ONLY ONE certification scope',
      hint_service: 'Service error',
      button: 'Approach NFC'
    },
    product: {
      title: 'Introduction',
      title_one: 'PUF technology',
      title_two: 'UIVS solution',
      title_three: 'Multi-app authentication',
      title_four: 'Scope of industry',
      desc_one: 'PUF (Physical Unclonable Functions) technology has been used in Fudan Micro’s RFID chips. The physical unique feature of PUF is used to ensure the tag’s uniqueness and the random feature is used to promote the embedded algorithm’s anti-attack ability. It is a perfect solution to the anti-counterfeit requirement of the products.',
      desc_two: 'Based on PUF technology, we provide Uniqueness Issuance and Validation Services (referred to as UIVS). Empower partners to reduce the cost of security system deployment and maintenance by users, Make it more convenient and economical for end users to use unique authentication services with high security features.',
      desc_three: 'The user only needs to use the NFC mobile phone to identify the authenticity, which is simple and convenient.Support the following super APP authentication queries, making authenticity traceability more credible.',
      desc_four: 'PUF technology give goods with strong uniqueness and features of "anti duplication, anti forgery and anti transfer", which is especially suitable for the following industries:',
      wine: 'wine',
      e_commerce: 'e_commerce',
      drug: 'drug',
      jewelry: 'jewelry',
      artwork: 'artwork',
      dairy: 'dairy'    
    },
    about: {
      title: 'About Us',
      descOne: 'Shanghai Fudan Microelectronics Group Company Limited is a leading company specializing in the design and development of ASIC and the provision of total solution in China. Since its founding in July 1998, FMSH has successfully evolved into an important player in the ASIC industry in China. FMSH went public in Hong Kong (stock No.: 1385) on August 4th, 2000, being known as the first listed IC design company from mainland China.',
      descTwo: 'Security and Identification Products Division, as a top-drawer part of Shanghai Fudan Microelectronics Group Company Limited, is engaged in the R&D and manufacturing of IOT products and the provision of total solutions. In the field of RFID, FMSH serves as a "basic RFID solution provider" who provides partners with security RFID+ enablement service, and works with channel partners and end users to shape a bright future.'
    },
    success: {
      title: 'Result',
      pass: 'Official Certification',
      hint: 'Hint: ',
      open: 'Be opened',
      noopen: 'Not open',
      notice: 'Statement: the above query results are for reference only. Please check whether the information is consistent with the real object, and make a comprehensive judgment based on other identification methods'
    },
    error: {
      title: 'Result',
      pass: 'Official Certification',
      notget: 'Product information is unavailable',
      button: 'Try Again'
    },
    update: {
      title: 'Update',
      app_name: 'Only One',
      version: 'Version Code:',
      check: 'Check Update'
    }
  },
  'zh-CN': {
    lang: 'zh',
    home: {
      center_black: '请将手机背面靠近',
      center_yellow: 'NFC标签',
      keep_phone: '请保持标签不要远离手机',
      about_us: '关于我们',
      product_introduced: '产品介绍',
      version_switch: '版本切换',
      update: '版本升级',
      feedback: '意见反馈',
      reminder: '温馨提示',
      hint_message: '未知错误',
      error_message: '该标签不在真品无双的验证范围内',
      hint_overtime: '请重试，保持标签接近手机',
      error_official: '此标签非官方发行',
      error_authentication: '该标签不在真品无双的认证范围内',
      hint_service: '服务异常',
      button: '碰一碰'
    },
    product: {
      title: '产品介绍',
      title_one: '芯片指纹技术',
      title_two: '唯一性发行与认证',
      title_three: '芯片支持多app平台认证',
      title_four: '适用行业',
      desc_one: 'PUF（Physical Unclonable Function），又称为“物理不可克隆功能”，其原理为每个芯片制造过程中，在微观上都会有细小的差异。通过采集并放大每个芯片在制造过程中产生的物理微小差异，作为芯片的唯一“特征”（类似于人类的指纹）信息。复旦微电子将 PUF 技术应用于 物品防伪 领域，该技术的特征简而言之就是： 无法复制的唯一性 。',
      desc_two: '复旦微电子基于PUF 技术，对外提供唯一性发行与认证服务（简称UIVS：Uniqueness Issuance and Validation Services）。赋能合作伙伴，降低用户对安全系统部署及维护的成本，让最终用户更便捷，更经济使用高安全特征的唯一性认证服务。',
      desc_three: '用户仅需使用NFC手机即可鉴别真伪，简单便捷。复旦微PUF芯片不仅支持真品无双，也支持以下超级APP认证查询，让鉴真溯源更具公信力。',
      desc_four: '“芯片指纹”技术赋予物品很强的唯一性，具备“防复制、防伪造、防转移”的特性，特适用于以下行业：',
      wine: '酒类防伪溯源',
      e_commerce: '电商平台产品验真',
      drug: '药品/保健品防伪溯源',
      jewelry: '珠宝证书防伪鉴定',
      artwork: '工艺美术品鉴真溯源',
      dairy: '乳制品行业防伪溯源'  
    },
    about: {
      title: "关于我们",
      descOne: '上海复旦微电子集团股份有限公司是从事超大规模集成电路的设计、开发和提供系统解决方案的专业公司 。自 1998 年 7 月成立以来，已成功地确立了 中国 集成电路设计行业中举足轻重的地位。公司于 2000 年8月4日在香港上市 股票编号 : 1385)，成为 中国大陆 集成电路设计行业第一家上市企业。',
      descTwo: '作为上海复旦微电子集团股份有限公司，最重要的安全与识别产品事业部，致力于物联网产品的研发制造以及整套解决方案的提供。其中，在 RFID 领域， 复旦微电子立足于“ RFID 基础方案供应商”角色，为广大合作伙伴提供“安全 RFID 的赋能服务，与 渠道合作伙伴与最终用户，共同成就美好的未来。',
    },
    success: {
      title: '鉴真结果',
      pass: '认证通过，系官方授权发行!',
      hint: '提示：',
      open: '商品已被开启',
      noopen: '商品未被开启',
      notice: '声明：以上查询结果仅供参考，请核对信息是否与实物相符,并结合其他鉴别方式综合判断。'
    },
    error: {
      title: '鉴真结果',
      pass: '认证通过，系官方授权发行!',
      notget: '商品信息暂时无法获取',
      button: '重试'
    },
    update: {
      title: '版本更新',
      app_name: '真品无双',
      version: '当前版本号',
      check: '检查更新'
    }
  }



}


//////////////////
// WEBPACK FOOTER
// ./common/lang.js
// module id = null
// module chunks = 